import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_5 = { key: 3 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("状态")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 上传 ")
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("展示")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("不展示")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("通知")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("不通知")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "帮助管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "关键字",
          value: _ctx.searches.keywords,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.keywords) = $event)),
          style: {"width":"200px"}
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onSearch,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: _ctx.pagination,
          style: {"margin-top":"10px"},
          onChange: _ctx.handleTableChange
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'content')
              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 0,
                  placement: "right",
                  style: {"min-width":"500px"}
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(record.content), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { type: "link" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (column.key === 'image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 1,
                  src: record.image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'is_show')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (record.is_show == '停用')
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.is_show), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (record.is_show == '启用')
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#108ee9"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.is_show), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin-left":"10px"},
                    onClick: ($event: any) => (_ctx.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该内容?",
                    onConfirm: ($event: any) => (_ctx.onDelete(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.modaltitle,
      onOk: _ctx.handleOk,
      width: "40%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.formState,
          rules: _ctx.rules,
          "label-col": { span: 2   },
          "wrapper-col": { span: 20 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              ref: "title",
              label: "文章标题",
              name: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.title,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.title) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "title",
              label: "图片",
              name: "image"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  name: "file",
                  "file-list": _ctx.fileList,
                  class: "avatar-uploader",
                  headers: _ctx.uploadHeaders,
                  action: _ctx.uploadAction,
                  data: _ctx.uploadFormData,
                  onChange: _ctx.handleChange
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_icon, { type: "upload" }),
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["file-list", "headers", "action", "data", "onChange"]),
                _createElementVNode("img", {
                  src: _ctx.formState.image,
                  style: {"width":"50px"}
                }, null, 8, _hoisted_10)
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "title",
              label: "内容",
              name: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_EditorComponent, {
                  ref: "editorComponentRef",
                  content: _ctx.formState.content
                }, null, 8, ["content"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "title",
              label: "排序",
              name: "sort"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.sort,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.sort) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "title",
              label: "是否展示",
              name: "is_show"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.is_show,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.is_show) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "title",
              label: "所属分类",
              name: "cid"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.cid,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.cid) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typelist, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "title",
              label: "是否通知",
              name: "is_notice"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.is_notice,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.is_notice) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"])
  ]))
}